"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.servers = exports.Globals = void 0;
var Globals;
exports.Globals = Globals;

(function (Globals) {
  Globals.cssPrefix = 'awxjs__';
})(Globals || (exports.Globals = Globals = {}));

var servers = {
  api: 'https://api.aerisapi.com',
  maps: 'https://maps.aerisapi.com'
};
exports.servers = servers;